/** 默认实例的Aixos配置 */
export const DEFAULT_ALOVA_OPTIONS = {
  // 请求超时时间,默认15秒
  timeout: 120 * 1000,
}

/** 默认实例的后端字段配置 */
export const DEFAULT_BACKEND_OPTIONS = {
  codeKey: 'code',
  dataKey: 'data',
  msgKey: 'message',
  successCode: 1000,
}

/** 请求不成功各种状态的错误 */
export const ERROR_STATUS = {
  default: '请求错误',
  400: '请求出现语法错误',
  401: '登录已过期，请重新登录',
  403: '服务器拒绝访问',
  404: '请求的资源不存在',
  405: '请求的方法未允许',
  408: '网络请求超时',
  500: '服务器内部错误',
  501: '服务器未实现请求功能',
  502: '错误网关',
  503: '服务不可用',
  504: '网关超时',
  505: 'http版本不支持该请求',
}

/** 没有错误提示的code */
export const ERROR_NO_TIP_STATUS = [1000]
